@if (user) {
<div class="header-wrapper">
  <div class="header-wrapper-left-header">
    <div>
      @if (companies?.length === 0 || !companies || companies === null) {
      <span
        class="header"
        >{{ headerMessage }}</span
      >
      }
      @if (companies?.length > 0) {
      <span
      class="mat-h2"
      >{{ 'Search_Results' | translate }}</span
    >
      }
    </div>
  </div>
  <div class="header-wrapper-right-search">
    <mat-form-field floatLabel="always" appearance="outline" >
      <mat-label class="mat-label">{{ 'SEARCH.search' | translate }}</mat-label>
      <input
        id="search"
        #search
        matInput
        (keyup)="monitorSearch(search.value)"
        [placeholder]="'COMPANY_BRANCHES.searchPlaceholder' | translate"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </div>
</div>
}

@if (!searching) {
<app-recent-company></app-recent-company>
}
<mat-card
  ><mat-card-content>
    @if (searching) {
    <div>
      @if (
          !loading &&
          noRecordFound &&
          (companies?.length === 0 || companies === null)
        ) {
      <app-not-found
        [displayMessage]="message"
      ></app-not-found>
      }

      <table
        mat-table
        [dataSource]="companiesDataSource"
        [ngClass]="noRecordFound ? 'hide' : ''"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef width="40%">
            {{ 'COMPANY_BRANCHES.name' | translate }}
          </th>
          <td mat-cell *matCellDef="let company">{{ company.name }}</td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'COMPANY_BRANCHES.address' | translate }}
          </th>
          <td mat-cell *matCellDef="let company">{{ company.address }}</td>
        </ng-container>

        <ng-container matColumnDef="sectorNumber">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'COMPANY_BRANCHES.sectorNumber' | translate }}
          </th>
          <td mat-cell *matCellDef="let company">{{ company.sectorNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="location">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'COMPANY_BRANCHES.location' | translate }}
          </th>
          <td mat-cell *matCellDef="let company">{{ company.location }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="$event.stopPropagation();  selectedRecord(row)"
        ></tr>
      </table>
      <mat-paginator
        [ngClass]="noRecordFound ? 'hide' : ''"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[10, 25, 50, 100]"
      ></mat-paginator>
    </div>
    }
</mat-card-content
></mat-card>
@if (_companySearchService._loading) {
<app-spinner></app-spinner>
}
